// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-R1":"R1_vanlife-roadtrips-R1__xDEH6"};